'use client';

import { EventMykissCardClicked } from '../../interfaces/events';
import { FishingWaterCarouselItem } from '../../interfaces/graphql';
import { FishingWaterCard } from '../Cards/FishingWaterCard/FishingWaterCard';
import { ContinuousCarousel } from '../Carousels/ContinuousCarousel/ContinuousCarousel';
import { Container } from '../Container/Container';

export interface IFishingWaterCarouselProps {
  dataTestId: string;
  title: string;
  waters?: FishingWaterCarouselItem[];
  isLoading?: boolean;
  /* An identifier for where this carousel is being used, e.g. species-top-waters */
  clickEventSource: EventMykissCardClicked['properties']['source'];
  /* An ID of the resource type where this carousel is being used, e.g. a species ID if it's on a species page */
  clickEventSourceId?: EventMykissCardClicked['properties']['source_id'];
  outerClass?: string;
  /* Use if carousel shown above the fold */
  priorityLoad?: boolean;
}

export const FishingWaterCarousel = ({
  dataTestId,
  title,
  waters = [],
  isLoading = false,
  clickEventSource,
  clickEventSourceId,
  outerClass,
  priorityLoad,
}: IFishingWaterCarouselProps) => {
  return (
    <Container>
      <ContinuousCarousel
        dataTestId={dataTestId}
        title={title}
        outerClass={outerClass}
        showContentLoader
        isLoading={isLoading}
      >
        {waters.map((water, index) => {
          const isPrioLoad = index === 0 && priorityLoad;
          return (
            <FishingWaterCard
              key={`${dataTestId}-${water._id}`}
              imageWidth={372}
              latitude={water.latitude}
              longitude={water.longitude}
              clickEventSource={clickEventSource}
              name={water.displayName}
              numberOfCatches={water.catchesCount}
              waterId={water._id}
              clickEventPosition={index}
              clickEventSourceId={clickEventSourceId}
              countryName={water.country?.countryName}
              regionName={water.region?.name || undefined}
              priorityLoad={isPrioLoad}
            />
          );
        })}
      </ContinuousCarousel>
    </Container>
  );
};
